<template>
    <div class="graph-tooltip">
        <img class="tooltip-icon" :src="require('@/assets/images/question.png')">
        <div class="tooltip-container">
            <div class="tooltip-header" v-if="$slots.header">
                <slot name="header"></slot>
            </div>
            <div class="tooltip-content" v-if="$slots.content">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "GraphTooltip",
}

</script>
<style scoped>
.graph-tooltip {
    position: relative;
    display: inline-block;
}
.graph-tooltip .tooltip-icon {
    width: 100%;
}
.graph-tooltip .tooltip-container {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    transition: all 0.2s;
    left: 0%;
    margin-left: 2rem;
    min-width: 330px;
    line-break: auto;
    font-family: 'NanumGothic';
    border-radius: 5px;
    background-color: rgb(246, 246, 250);
    box-shadow: 0px 0px 3px grey;
    z-index: 1;
    border: none;
    font-weight: normal;
    overflow: hidden;
}
.graph-tooltip .tooltip-container div {
    padding: 0.8em;
}
.graph-tooltip .tooltip-container .tooltip-header {
    display: block;
    font-weight: bold;
    /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
}
.graph-tooltip .tooltip-container .tooltip-content {
    background-color: white;
}
.graph-tooltip .tooltip-icon:hover ~ .tooltip-container {
    visibility: visible;
    opacity: 1;
}

</style>